var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8815 13.168L16.5979 14.5918C17.3999 13.4051 17.8682 11.9744 17.8682 10.4343C17.8682 8.78228 17.3293 7.25611 16.4178 6.02197L14.7627 7.51652C15.3252 8.34948 15.6537 9.35354 15.6537 10.4343C15.6537 11.4366 15.3712 12.3729 14.8815 13.168Z",
    fill: "#6BBBAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2031 21.5926L15.1057 17.1553L16.7326 15.653L20.83 20.0903L19.2031 21.5926Z",
    fill: "#6BBBAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6206 5.35107C10.5841 5.10915 9.49843 5.18988 8.5091 5.58243C7.51977 5.97498 6.67409 6.6606 6.08543 7.54736C5.49677 8.43412 5.19326 9.47965 5.2156 10.5438C5.23794 11.6079 5.58505 12.6398 6.21041 13.5011C6.83576 14.3623 7.70947 15.0119 8.7144 15.3625C9.71933 15.7132 10.8075 15.7483 11.8329 15.4631C12.8583 15.1779 13.7721 14.5861 14.4516 13.7669L16.156 15.1807C15.1881 16.3474 13.8867 17.1904 12.4263 17.5966C10.9658 18.0028 9.41604 17.9528 7.98478 17.4533C6.55351 16.9539 5.30914 16.0288 4.41848 14.8021C3.52783 13.5755 3.03345 12.1058 3.00164 10.5903C2.96982 9.07467 3.40209 7.58559 4.24049 6.32263C5.07888 5.05966 6.28334 4.08318 7.69238 3.52409C9.10142 2.965 10.6477 2.85003 12.1239 3.19458C13.6002 3.53913 14.9358 4.32673 15.9518 5.45182L14.3083 6.93594C13.5949 6.14599 12.6571 5.59299 11.6206 5.35107Z",
    fill: "#6BBBAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.16b9d96f9e1e61e594e30ab72f570282.svg";
export { ForwardRef as ReactComponent };